import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Loader from "../components/Loader";
import Error from "./Error";

const CountryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 10rem;

  h2 {
    margin-bottom: 5rem;
    font-size: 5rem;
  }

  @media (width: 768px) {
    padding: 2rem 1rem;
  }
`;

const Flag = styled.img`
  width: 30rem;
  height: auto;
  margin-bottom: 5rem;
  border-radius: 1rem;
`;

const InfoGroup = styled.div`
  width: 30rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  font-size: 1.5rem;

  span {
    font-weight: bold;
    color: var(--color-grey-900);
    font-size: 1.5rem;
  }
`;

const MapButton = styled.button`
  margin-top: 5rem;
  padding: 1rem 2rem;
  background-color: var(--color-grey-700);
  color: var(--color-grey-100);
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    scale: 1.05;
  }
`;

function CountryDetails() {
  const { cca3 } = useParams();
  const [countryDetails, setCountryDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://restcountries.com/v3.1/alpha/${cca3}`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.length > 0) {
          setCountryDetails(data[0]);
        }
        setLoading(false); // перемістити сюди
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [cca3]);

  return (
    <CountryContainer>
      {loading ? (
        <Loader />
      ) : countryDetails ? (
        <>
          <h2>{countryDetails.name.common}</h2>
          <Flag
            src={countryDetails.flags.png}
            alt={`Flag of ${countryDetails.name.common}`}
          />
          <InfoGroup>
            <span>Capital:</span> {countryDetails.capital}
          </InfoGroup>
          <InfoGroup>
            <span>CCA2:</span> {countryDetails.cca2}
          </InfoGroup>
          <InfoGroup>
            <span>CCA3:</span> {countryDetails.cca3}
          </InfoGroup>
          <InfoGroup>
            <span>Region:</span> {countryDetails.region}
          </InfoGroup>
          <InfoGroup>
            <span>Currency:</span>{" "}
            {Object.keys(countryDetails.currencies).join(", ")}
          </InfoGroup>
          <InfoGroup>
            <span>TLD:</span> {countryDetails.tld[0]}
          </InfoGroup>
          <InfoGroup>
            <span>Population:</span>{" "}
            {countryDetails.population.toLocaleString()}
          </InfoGroup>
          <InfoGroup>
            <span>Languages:</span>{" "}
            {Object.values(countryDetails.languages).join(", ")}
          </InfoGroup>
          <MapButton
            onClick={() => window.open(countryDetails.maps.googleMaps)}
          >
            Open in Google Maps
          </MapButton>
        </>
      ) : (
        <Error />
      )}
    </CountryContainer>
  );
}

export default CountryDetails;
